import { render, staticRenderFns } from "./DamageReasonItem.vue?vue&type=template&id=c1fa8bba&"
import script from "./DamageReasonItem.vue?vue&type=script&lang=js&"
export * from "./DamageReasonItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports